import { MutationTree } from 'vuex';
import { RootState } from './types';
import { SET_SIDEBAR_OPEN, SET_LAYERSELECT_OPEN, SET_SURVEY_DATA, SET_LAYERS, SET_SELECTED_PLACE, SET_MARKER_RADIUS, SET_IS_LAYER_SELECTED, SET_LOADER, SET_OPEN_ANSWER, SET_MULTICHOICE_ANSWER, SET_SINGLECHOICE_ANSWER, ADD_FILE, REMOVE_FILE, SET_SUCCESS, SET_QUESTIONNAIRE_STEP, SET_QUESTIONNAIRE_STEPS, SET_QUESTIONNAIRE_ERROR, SET_MAP_LOADED } from './types';

export const mutations: MutationTree<RootState> = {
    [SET_SURVEY_DATA]: (state, payload) => {
        state.survey = payload;
    },

    [SET_LAYERS]: (state, payload) => {
        state.survey.layers = payload;
    },

    [SET_SELECTED_PLACE]: (state, payload) => {
        state.userData.selectedPlace = payload;
    },

    [SET_SIDEBAR_OPEN]: (state, payload) => {
        state.isSidebarOpen = payload;
    },

    [SET_LAYERSELECT_OPEN]: (state, payload) => {
        state.isLayerselectOpen = payload;
    },

    [SET_LOADER]: (state, payload) => {
        state.loader = payload;
    },

    [SET_MAP_LOADED]: (state, payload) => {
        state.mapLoaded = payload;
    },

    [SET_SUCCESS]: (state, payload) => {
        state.success = payload;
    },

    [SET_MARKER_RADIUS]: (state, payload) => {
        state.mapCircleRadius = payload;
    },

    [SET_QUESTIONNAIRE_STEP]: (state, payload) => {
        state.currentQuestionnaireStep = payload;
    },

    [SET_QUESTIONNAIRE_STEPS]: (state, payload) => {
        state.questionnaireSteps = payload;
    },

    [SET_QUESTIONNAIRE_ERROR]: (state, payload) => {
        state.questionnaireError = payload;
    },

    [SET_OPEN_ANSWER]: (state, payload) => {
        const { id, openAnswer } = payload;
        const answer: any = state.userData.userAnswers.find((ans: any) => ans.questionId === id);

        if (answer && {}.hasOwnProperty.call(answer, 'openAnswer')) {
            answer.openAnswer = openAnswer;
        } else {
            state.userData.userAnswers.push({ questionId: id, openAnswer });
        }
    },

    [SET_MULTICHOICE_ANSWER]: (state, payload) => {
        const { questionId, answerId, isChecked } = payload;

        const answerObject: any = state.userData.userAnswers.find((q: Record<string, any>) => q.questionId === questionId);

        if (!answerObject && isChecked) {
            state.userData.userAnswers.push({ questionId, answers: [{ id: answerId }] });
        } else if (answerObject && {}.hasOwnProperty.call(answerObject, 'answers')) {
            const answer = answerObject.answers.find(ans => ans.id === answerId);

            if (!answer && isChecked) {
                answerObject.answers.push({ id: answerId });
            } else if (answer && !isChecked) {
                const index = answerObject.answers.findIndex(a => a.id === answerId);
                answerObject.answers.splice(index, 1);
            }
        }
    },

    [SET_SINGLECHOICE_ANSWER]: (state, payload) => {
        const { questionId, answerId, isChecked } = payload;

        const answerObject: any = state.userData.userAnswers.find((q: Record<string, any>) => q.questionId === questionId);

        if (!answerObject && isChecked) {
            state.userData.userAnswers.push({ questionId, answers: [{ id: answerId }] });
        } else if (answerObject && {}.hasOwnProperty.call(answerObject, 'answers')) {
            const answer = answerObject.answers.find(ans => ans.id === answerId);
            answerObject.answers = [];

            if (isChecked && !answer) {
                answerObject.answers.push({ id: answerId });
            }
        }
    },

    [SET_IS_LAYER_SELECTED]: (state, payload) => {
        const { id, value } = payload;
        const layer = state.survey.layers.find(layer => layer.id === id);

        if (layer) {
            layer.isSelected = value;
        }
    },

    [ADD_FILE]: (state, payload) => {
        state.userData.uploadedFiles.push(payload);
    },

    [REMOVE_FILE]: (state, fileId) => {
        const file = state.userData.uploadedFiles.find(file => file.id === fileId);

        if (file) {
            const index = state.userData.uploadedFiles.findIndex(file => file.id === fileId);
            state.userData.uploadedFiles.splice(index, 1);
        }
    }
};
